/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    em: "em",
    a: "a",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, React.createElement(_components.em, null, "Traduzido automaticamente do inglês. ", React.createElement(_components.a, {
    href: "/whatsnew/en/timepage/2.7"
  }, "Clique aqui para ler original."))), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, "Timepage agora é um serviço de adesão. Se você já tem o Timepage, o aplicativo não mudou e você automaticamente tem uma assinatura gratuita. Para obter mais informações, verifique o FAQ dentro do Timepage. Agradecemos seu apoio contínuo. Fique ligado para novidades emocionantes em breve!"), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, "Adicionado suporte para três novos idiomas - já faz muito tempo, mas o Timepage agora oferece suporte para espanhol, português (brasileiro) e russo!"), "\n"), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
